import React from 'react';
import { FREE_PACKAGE_CODES } from '@src/constants/package';
import { Skeleton } from '@mui/material';
import { useSelector } from 'react-redux';
import moment from 'moment';
import { CODE_TASK } from '@src/constants/referral';
import Typography from '@src/new-components/Typography';
import { useTranslation } from 'react-i18next';
import { COLOR } from '@src/styles/color';
import { StyledRewardTasks } from './index.style';
import Task from './Task';

const RewardTasks = ({ tasks, loading }) => {
  const { t } = useTranslation();

  const user = useSelector((state) => state.auth.user);

  const registeredAt = moment(user?.createdAt);
  const now = moment();
  const diffHours = now.diff(registeredAt, 'hours');

  const skeletonLoading = () =>
    Array.from({ length: 2 }).map(() => (
      <Skeleton
        style={{ borderRadius: '12px' }}
        variant="rectangular"
        width="100%"
        height={80}
      />
    ));

  const isFreeUser = FREE_PACKAGE_CODES.includes(user?.packageCode);

  const taskCompleted = (task) =>
    task?.maxRepeats > 0 && task?.totalCompletedTimes >= task?.maxRepeats;

  const hasUncompletedReferralTask = tasks?.some(
    (task) =>
      task?.code === CODE_TASK.REFERRAL_CODE_APPLIED_SUCCESSFULLY &&
      !taskCompleted(task),
  );

  if (diffHours > 24 && hasUncompletedReferralTask) {
    return null;
  }

  return (
    <StyledRewardTasks>
      <Typography
        variant="body-20-bold"
        color={COLOR.descriptionGray}
        className="title-section-text"
      >
        {t('bonus')}
      </Typography>
      {loading
        ? skeletonLoading()
        : tasks?.flatMap((task) => {
            if (
              task?.code === CODE_TASK.REFEREE_FIRST_PAID_ORDER &&
              !isFreeUser &&
              !taskCompleted(task)
            ) {
              return [];
            }
            return (
              <Task
                hasUncompletedReferralTask={hasUncompletedReferralTask}
                key={task.id}
                task={task}
                taskCompleted={taskCompleted(task)}
              />
            );
          })}
    </StyledRewardTasks>
  );
};

export default RewardTasks;
